import axios from "axios";
import { saveAs } from "file-saver";
import "./../assets/sass/style.css";
import "./../assets/sass/_login.scss";
import "./../assets/sass/_review.scss";
import DashboardTable from "./dashboardTable.js";
import htmlDocx from "html-docx-js/dist/html-docx";
import { useDispatch, useSelector } from "react-redux";
import { Loader2 } from "./webWorkers/LoaderFile/Loader";
import React, { useEffect, useRef, useState } from "react";
import { clearLoaders } from "../features/setting/apiSlice";
import TablePagination from "@mui/material/TablePagination";
import DashboardReviewModals from "./dashboardReviewModals.jsx";
import { API_Link, validateHeader } from "./../commons/Constants";
import { FaTrashAlt, FaUndo, FaExclamationTriangle } from "react-icons/fa";

function DashboardReview() {
  const MD5hash = validateHeader();
  const divRef = useRef(null);
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.token;
  const loaders = useSelector((state) => state.loader.loaders);

  //////----useState-----/////

  const [text, setText] = useState("");
  const [show, setShow] = useState(false);
  const [review, setReview] = useState("");
  const [timer, setTimer] = useState(null);
  const [show1, setShow1] = useState(false);
  const [message, setMessage] = useState("");
  const [reviewId, setReviewId] = useState();
  const [progress, setProgress] = useState(0);
  const [tabKey, initTabKey] = useState("one");
  const [reviewList, setReviewList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [invitations, setInvitations] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [reviewTypes, setReviewTypes] = useState([]);
  const [invitataionId, setInvitationId] = useState();
  const [searchResults, setSearchResults] = useState([]);
  const [filtered_review, setFilteredReview] = useState();
  const [deleteReviews, setDeletedReviews] = useState([]);
  const [reviewsPerPage, setReviewsPerPage] = useState(10);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isShowDeleted, setIsShowDeleted] = useState(false);
  const [emailSuggestion, setEmailSuggestion] = useState([]);
  const [isLoadingTable, setIsLoadingTable] = useState(false);
  const [showCofirmDelete, setShowCofirmDelete] = useState(false);
  const [isLoadingProgress, setIsLoadingProgress] = useState(false);
  const [showEditInvitation, setShowEditInvitation] = useState(false);
  const [studyId, setStudyId] = useState(localStorage.getItem("studyId"));
  const [showNewInvitationModal, setShowNewInvitationModal] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  // const [value, setValue] = useState();
  const [reviewById, setReviewByID] = useState({
    title: "",
    review_type: "",
    tentative_completion_date: "",
    is_followup: "",
  });
  const [inviteUser, setInviteUser] = useState({
    name: "",
    email: "",
  });
  const [isFetchingDeletedReviews, setIsFetchingDeletedReviews] =
    useState(false);

  // edit review

  const { title, review_type, tentative_completion_date, is_followup } =
    reviewById;

  const { name, email } = inviteUser;
  const indexOfLastReview = currentPage * reviewsPerPage;
  const indexOfFirstReview = indexOfLastReview - reviewsPerPage;

  // const [isDownload, setIsDownload] = useState(false);
  // const [selectValue, setSelectValue] = useState("");
  const studyCheck = (event) => {
    // setSelectValue(event.target.value);
    localStorage.setItem("studyId", event.target.value);
    setStudyId(localStorage.getItem("studyId"));
  };

  let stage =
    tabKey === "one"
      ? "1"
      : tabKey === "two"
      ? "2"
      : tabKey === "three"
      ? "3"
      : tabKey === "four"
      ? "4"
      : "";

  const handleExport = () => {
    const risData = searchResults
      ?.map((item, index) => {
        const authors = item.authors
          ?.split(",")
          ?.map((author) => author.trim())
          .join("\nA1  - ");
        return (
          `TY  - JOUR\n` +
          `ID  - ${item.id}\n` +
          `T1  - ${item.title}\n` +
          `A1  - ${authors}\n` +
          `CA  - ${item.created_at}\n` +
          `AB  - ${item.abstract}\n` + // N2 is the RIS tag for abstract
          `CS  - ${item.current_stage}\n` + // Custom tag for stage
          `DO  - ${item.doi}\n` + // DOI if available
          `J1  - ${item.journal}\n` + // Journal name
          `S1  - ${item.source}\n` + // Publisher/source
          `PI  - ${item.pico_search_id}\n` + // Custom tag for search ID
          `PD  - ${item.pub_date}\n` + // Custom tag for publication date
          `FP  - ${item.file_path}\n` + // Custom tag for file path
          `RI  - ${item.review_id}\n`
        ); // Custom tag for review ID
      })
      .join("\n");

    const blob = new Blob([risData], {
      type: "application/x-research-info-systems",
    });

    saveAs(blob, "data.ris");
    setIsLoadingProgress(false);
    setShow1(false);
    setSearchResults([]);
  };

  const toggleSearchBar = () => {
    setShowSearchBar((prev) => !prev);
  };

  const getReviews = () => {
    setIsLoadingTable(true);
    var config = {
      method: "get",
      url: `${API_Link}getReviews`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
    };
    axios(config)
      .then(function (response) {
        setDeletedReviews([]);
        const reviewdata = JSON.stringify(response.data.reviews);
        const valuesArray = JSON.parse(reviewdata);
        let sorted = valuesArray.sort((a, b) => (a.id < b.id ? 1 : -1));
        setFilteredReview(valuesArray);
        setIsShowDeleted(false);
        setIsLoadingTable(false);
      })
      .catch(function (error) {
        console.log(error);
        setIsLoadingTable(false);
      });
  };

  const getDeletedReviews = () => {
    setIsLoadingTable(true);
    setIsFetchingDeletedReviews(true);
    var config = {
      method: "get",
      url: `${API_Link}getReviews`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
      params: {
        status: "inactive",
      },
    };
    axios(config)
      .then(function (response) {
        setFilteredReview([]);
        setDeletedReviews(response.data.reviews);
        setIsFetchingDeletedReviews(false);
        setIsShowDeleted(true);
        setIsLoadingTable(false);
      })
      .catch(function (error) {
        console.log(error);
        setIsFetchingDeletedReviews(false);
      });
  };

  const editReview = (id) => {
    setShowEditModal(true);
    setReviewId(id);
    getReviewsByID(id);
  };
  const getReviewsByID = async (id) => {
    //
    await axios
      .get(`${API_Link}getReviews`, {
        params: {
          id: id,
        },
        headers: {
          "Content-Type": "application/json",
          "misr-auth": MD5hash,
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function (response) {
        setReviewByID({
          title: response.data.reviews[0].title,
          review_type: response.data.reviews[0].review_type.id,
          tentative_completion_date:
            response.data.reviews[0].tentative_completion_date,
          is_followup:
            response.data.reviews[0].is_followup === true ? "1" : "0",
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const manageInvitation = (id) => {
    setShowEditInvitation(true);
    setReviewId(id);
    getInvitationById(id);
  };
  const getInvitationById = async (id) => {
    //
    await axios
      .get(`${API_Link}getInvitations`, {
        params: {
          review_id: id,
        },
        headers: {
          "Content-Type": "application/json",
          "misr-auth": MD5hash,
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function (response) {
        setInvitations(response.data.invitations);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getReviewsList = () => {
    var config = {
      method: "get",
      url: `${API_Link}getReviewsList`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
    };
    axios(config)
      .then(function (response) {
        const reviewdata = JSON.stringify(response.data.reviews);
        const valuesArray = JSON.parse(reviewdata);
        setReviewList(valuesArray);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getReviewTypes = () => {
    var config = {
      method: "get",
      url: `${API_Link}getReviewTypes`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        const resData = response;
        setReviewTypes(resData.data.reviewTypes);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    getReviews();
    getReviewTypes();
    getReviewsByID(reviewId);
    getInvitationById(reviewId);
    getReviewsList();
  }, []);

  useEffect(() => {
    if (show == false) dispatch(clearLoaders());
  }, [show]);

  useState(() => {
    localStorage.setItem("pageId", "2222");
    localStorage.setItem("subPageId", "2223");
  }, []);

  const handleClose = () => {
    setShow(false);
    dispatch(clearLoaders());
  };

  const handleClose1 = () => {
    setShow1(false);
    // setIsDownload(false);
    dispatch(clearLoaders());
  };
  const handleCloseEdit = () => {
    setShowEditModal(false);
  };
  // const handleSelect = (e) => {
  //   setValue(e);
  // };

  const handleChange = (e) => {
    setReviewByID({ ...reviewById, [e.target.name]: e.target.value });
  };
  const handleSubmit = () => {
    let data = reviewById;
    axios
      .post(`${API_Link}addReview?id=${reviewId}`, data, {
        headers: {
          "misr-auth": MD5hash,
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        res.data.status === 1 &&
          setMessage({
            code: 200,
            message: "Data Has been added successfully.",
          });
        res.data.status === 0 &&
          setMessage({ code: 400, message: res.data.error_message });
      })
      .catch((error) => {
        alert(JSON.stringify(error.response.data.error_message));
      })
      .finally(() => {
        setShowEditModal(false);
        window.location.reload(false);
      });
  };

  const handleCloseInvitation = () => {
    setShowEditInvitation(false);
    setInvitations([]);
  };
  // New Invitation
  const openNewInvitationModal = () => {
    setShowNewInvitationModal(true);
  };

  const handleChangeNewInvite = (e) => {
    setInviteUser({ ...inviteUser, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (!isLoadingProgress && searchResults.length > 0) {
      setTimeout(() => {
        handleExport();
        setSearchResults([]);
      }, 500);
    }
  }, [isLoadingProgress, searchResults]);

  const downloadAsDocx = () => {
    const allLoaded = Object.values(loaders).every((value) => value === false);
    const empty = Object.keys(loaders).length;
    if (divRef.current && allLoaded && empty) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = divRef.current.innerHTML;
      const images = tempDiv.querySelectorAll("img");
      images.forEach((img) => img.remove());
      const links = tempDiv.querySelectorAll("a");
      links.forEach((link) => {
        const textNode = document.createTextNode(link.textContent);
        link.parentNode.replaceChild(textNode, link);
      });
      tempDiv.innerHTML = tempDiv.innerHTML.replace(/Jump to Annotation/g, "");
      const content = tempDiv.innerHTML;
      if (!content.trim()) {
        console.warn("The content to be exported is empty.");
        // setLoading(false); // Hide the spinner
        return;
      }
      const css = `
            <style>
              @page WordSection1 { size: 841.95pt 595.35pt; mso-page-orientation: landscape; }
              div.WordSection1 { page: WordSection1; }
              table { border-collapse: collapse; width: 100%; }
              .table-bordered-td td { border: 1px gray solid; padding: 2px; }
            </style>
          `;
      const htmlContent = `<html><head>${css}</head><body>${content}</body></html>`;
      try {
        const converted = htmlDocx.asBlob(htmlContent);
        saveAs(converted, "document.docx");
      } catch (error) {
        console.error("Error while converting HTML to DOCX:", error);
      }
    } else {
      console.warn("divRef is not available or has no content.");
    }
    dispatch(clearLoaders());
    // setLoading(false);
  };
  const handleSubmitInvitation = () => {
    var config = {
      method: "post",
      url: `${API_Link}addInvitation`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
      data: {
        review_id: reviewId,
        stage: stage,
        name: inviteUser.name,
        email: text,
      },
    };
    setIsLoading(true);
    axios(config)
      .then((response) => {
        if (response.data.status === 1) {
          setShowNewInvitationModal(false);
          getInvitationById(reviewId);
          setIsLoading(false);
          setInviteUser({});
          setText("");
        }
        if (response.data.status === 0) {
          alert(response.data.error_message);
        }
      })
      .catch((error) => {
        alert(error);
      });
  };
  const handleCloseNewInvite = () => {
    setShowNewInvitationModal(false);
    setInviteUser([]);
    setText("");
  };

  const deleteInvitation = (id) => {
    setInvitationId(id);
    setShowCofirmDelete(true);
  };
  const handleCloseCofirmDelete = () => {
    setShowCofirmDelete(false);
  };
  const handleDelete = () => {
    var config = {
      method: "post",
      url: `${API_Link}deleteInvitation`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
      data: {
        id: invitataionId,
        review_id: reviewId,
      },
    };
    axios(config)
      .then((response) => {
        if (response.data.status === 1) {
          getInvitationById(reviewId);
          setShowCofirmDelete(false);
        }
      })
      .catch((error) => {
        alert(error);
      });
  };

  //////////-------> Sorting <---------\\\\\\\\\
  const handleSort = (columnKey) => {
    const newDirection =
      sortConfig.key === columnKey && sortConfig.direction === "asc"
        ? "desc"
        : "asc";
    setSortConfig({ key: columnKey, direction: newDirection });
  };
  //////////-------><---------\\\\\\\\\
  const sortedReviews = React.useMemo(() => {
    if (!sortConfig.key) return filtered_review;

    return [...filtered_review].sort((a, b) => {
      let valueA = a[sortConfig.key];
      let valueB = b[sortConfig.key];

      // Handle nested keys
      if (sortConfig.key.includes(".")) {
        const keys = sortConfig.key.split(".");
        valueA = keys.reduce((obj, key) => obj[key], a);
        valueB = keys.reduce((obj, key) => obj[key], b);
      }

      // Compare values
      if (typeof valueA === "string") {
        valueA = valueA.toLowerCase();
        valueB = valueB.toLowerCase();
      }

      if (valueA < valueB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valueA > valueB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [filtered_review, sortConfig]);
  const filteredReviews = sortedReviews?.filter(
    (review) =>
      searchQuery.length < 1 ||
      review.title.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const paginatedReviews = React.useMemo(() => {
    const start = currentPage * reviewsPerPage;
    const end = start + reviewsPerPage;
    return filteredReviews?.slice(start, end); // Slice the sorted reviews for pagination
  }, [filteredReviews, currentPage, reviewsPerPage]);
  const [currentReviews, setcurrentReviews] = useState(
    filtered_review
      ? filtered_review.slice(indexOfFirstReview, indexOfLastReview)
      : []
  );
  const handleChangeEmail = (e) => {
    const { value } = e.target;
    setText(value);
    clearTimeout(timer);
    var config = {
      method: "get",
      url: `${API_Link}getEmailsList`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
      params: {
        keyword: text,
      },
    };
    setTimer(
      setTimeout(async () => {
        if (value.length > 1) {
          axios(config)
            .then((res) => {
              setEmailSuggestion(res.data.emails);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }, 500)
    );
  };
  const suggestionHandler = (text) => {
    setText(text);
    setEmailSuggestion([]);
  };

  const ViewReport = (id, download) => {
    // setIsDownload(download);
    setShow(true);
    setReview(id);
  };

  const getPermissionCall = (review_id) => {
    var config = {
      method: "get",
      url: `${API_Link}getAllowedStages?review_id=${review_id}`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
    };
    axios(config)
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchSearchResults = async (review_id) => {
    let page = 1;
    let totalPages = 1;
    const perPage = 100;

    try {
      const studyId = review_id;
      let allResults = [];
      setIsLoadingProgress(true);
      do {
        const config = {
          method: "get",
          url: `${API_Link}getReviewArticles`,
          params: {
            review_id: studyId,
            page: page,
            per_page: perPage,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "misr-auth": MD5hash,
          },
        };

        const response = await axios(config);
        const resData = response?.data?.articles;

        // Append new results to existing results
        allResults = [...allResults, ...resData?.data];

        // Update state with the current set of results
        setSearchResults((prevResults) => [...prevResults, ...resData?.data]);

        totalPages = resData?.last_page; // Update totalPages
        page++;
        const progressPercent = Math.min((page / totalPages) * 100, 100);
        setProgress(progressPercent);
      } while (page <= totalPages);

      setIsLoadingProgress(false);
    } catch (error) {
      setIsLoadingProgress(false);
      console.log(error);
    }
  };

  const DownloadReport = (id, download, review_id) => {
    setIsLoadingProgress(true);
    setProgress(0);
    getPermissionCall(review_id);
    fetchSearchResults(review_id);
    // setIsDownload(download);
    setShow1(true);
    setReview(id);
  };

  const toggleReviewActiveStatus = async (reviewId, status) => {
    try {
      setIsLoadingTable(true);
      const headers = {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      };
      const apiUrl = `${API_Link}reviews/toggle-active-status`;

      // Request payload
      const payload = {
        id: reviewId,
        status, // "active" or "inactive"
      };

      // Make the PATCH request with headers
      const response = await axios.patch(apiUrl, payload, { headers });

      if (response?.data?.status === 1) {
        if (status === "inactive") {
          setFilteredReview((prevReviews) =>
            prevReviews.filter((review) => review.id !== reviewId)
          );
          setIsLoadingTable(false);
        } else {
          setDeletedReviews((prevReviews) =>
            prevReviews.filter((review) => review.id !== reviewId)
          );
          setIsLoadingTable(false);
        }
      }
    } catch (error) {
      console.error("Error:", error);
      setIsLoadingTable(false);
    }
  };

  //////////-------> Pagination <-------\\\\\\\\\\
  const handleChangeRowsPerPage = (e) => {
    setReviewsPerPage(parseInt(e.target.value));
    setCurrentPage(0); // Reset to page 1
  };
  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };
  //////////-------><-------\\\\\\\\\\
  useEffect(() => {
    setcurrentReviews(
      sortedReviews
        ? sortedReviews.slice(indexOfFirstReview, indexOfLastReview)
        : []
    );
    setCurrentPage(0); // Reset to first page (0-based)
  }, [sortedReviews]);
  return (
    <div>
      <div className="d-flex row">
        <div className="text-end">
          {!isShowDeleted ? (
            <button onClick={getDeletedReviews} className="recycle-bin-btn p-1">
              Recycle Bin <FaTrashAlt style={{ fontSize: "18px" }} />
            </button>
          ) : (
            <button onClick={getReviews} className="sort-filter-btn p-1">
              Back to List
            </button>
          )}
        </div>
      </div>

      <div className="row">
        <div className="padding-table">
          <div className="table--template review-table ">
            {!isLoadingTable && !isShowDeleted && (
              <>
                <DashboardTable
                  toggleReviewActiveStatus={toggleReviewActiveStatus}
                  handleSort={handleSort}
                  sortConfig={sortConfig}
                  toggleSearchBar={toggleSearchBar}
                  showSearchBar={showSearchBar}
                  searchQuery={searchQuery}
                  sortedReviews={paginatedReviews}
                  setSearchQuery={setSearchQuery}
                  ViewReport={ViewReport}
                  DownloadReport={DownloadReport}
                  // handleSelect={handleSelect}
                  editReview={editReview}
                  manageInvitation={manageInvitation}
                />
                <div className="dashboard-pagination d-flex align-items-center m-auto">
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    component="div"
                    count={sortedReviews?.length}
                    rowsPerPage={reviewsPerPage}
                    page={currentPage}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage="Records per page:"
                  />
                </div>
              </>
            )}
            {isLoadingTable && (
              <div className="review-loader">
                <Loader2 />
              </div>
            )}
            {!isFetchingDeletedReviews &&
            isShowDeleted &&
            deleteReviews?.length ? (
              <>
                <table className="table table-striped">
                  <thead className="table-head">
                    <tr>
                      <th>Name</th>
                      <th className="heading-table">Type</th>
                      <th className="heading-table">Stage</th>
                      <th className="heading-table">Start Date</th>
                      <th className="heading-table">End Date</th>
                      <th className="heading-table">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {deleteReviews &&
                      deleteReviews?.map((review, index) => (
                        <tr key={index} className="table-row">
                          <td className="title-column">{review.title}</td>
                          <td className="other-column">
                            {review.review_type.description}
                          </td>
                          <td
                            className="other-column"
                            style={{ textAlign: "center" }}
                          >
                            {review.final_completion_date ? (
                              <span className="bg-success px-2 py-1 text-light rounded">
                                Completed
                              </span>
                            ) : review.current_stage.label ===
                              "Full Text Screening" ? (
                              <span className="bg-light-blue px-2 py-1 text-light rounded">
                                {review.current_stage.label}
                              </span>
                            ) : (
                              <span className="bg-light-grey px-2 py-1 text-light rounded">
                                {review.current_stage.label}
                              </span>
                            )}
                          </td>
                          <td className="other-column">
                            {review.created_at.slice(0, 10)}
                          </td>
                          <td className="other-column">
                            {review.final_completion_date ||
                              review.tentative_completion_date}
                          </td>
                          <td>
                            <button
                              className="recycle-bin-btn"
                              title="Undo"
                              onClick={() =>
                                toggleReviewActiveStatus(review.id, "active")
                              }
                            >
                              <FaUndo />
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </>
            ) : (
              !isLoadingTable &&
              deleteReviews?.length === 0 &&
              isShowDeleted && (
                <div className="no-data-found-main">
                  <h5 className="no-data-found text-muted m-auto opacity-50">
                    <FaExclamationTriangle size={50} color="orange" />
                    <span className="ms-3">No data in Recycle Bin</span>
                  </h5>
                </div>
              )
            )}
          </div>
        </div>

        <div>
          <DashboardReviewModals
            show={show}
            handleClose={handleClose}
            divRef={divRef}
            review={review}
            show1={show1}
            handleClose1={handleClose1}
            progress={progress}
            showEditModal={showEditModal}
            handleCloseEdit={handleCloseEdit}
            title={title}
            handleChange={handleChange}
            review_type={review_type}
            reviewTypes={reviewTypes}
            tentative_completion_date={tentative_completion_date}
            is_followup={is_followup}
            studyId={studyId}
            studyCheck={studyCheck}
            reviewList={reviewList}
            handleSubmit={handleSubmit}
            showEditInvitation={showEditInvitation}
            openNewInvitationModal={openNewInvitationModal}
            handleCloseInvitation={handleCloseInvitation}
            tabKey={tabKey}
            initTabKey={initTabKey}
            invitations={invitations}
            deleteInvitation={deleteInvitation}
            showNewInvitationModal={showNewInvitationModal}
            handleCloseNewInvite={handleCloseNewInvite}
            isLoading={isLoading}
            name={name}
            text={text}
            handleChangeEmail={handleChangeEmail}
            emailSuggestion={emailSuggestion}
            suggestionHandler={suggestionHandler}
            handleSubmitInvitation={handleSubmitInvitation}
            showCofirmDelete={showCofirmDelete}
            handleCloseCofirmDelete={handleCloseCofirmDelete}
            handleDelete={handleDelete}
            handleChangeNewInvite={handleChangeNewInvite}
            downloadAsDocx={downloadAsDocx}
          />
        </div>
      </div>
    </div>
  );
}
export default DashboardReview;
